// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_AcumularDadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /fechamentos/acumular_dados
 *
 * POST /fechamentos/acumular_dados/{id}
 *
 * Returns accumulated data after accumulation
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_AcumularDadosResponseDados {
id: number
numero_clientes: number
faturamento_vendas_realizadas: number
total_recebimentos_conferidos: number
total_recebido_dinheiro: number
total_despesas_pagas: number
}

export type Fechamentos_AcumularDadosResponse = ApiResponse<Fechamentos_AcumularDadosResponseDados>;

registerResponseContract('Fechamentos_AcumularDadosResponse', {
  id:                            { type: 'number',  required: true },
  numero_clientes:               { type: 'number',  required: true },
  faturamento_vendas_realizadas: { type: 'number',  required: true },
  total_recebimentos_conferidos: { type: 'number',  required: true },
  total_recebido_dinheiro:       { type: 'number',  required: true },
  total_despesas_pagas:          { type: 'number',  required: true },
})
